<template>
  <v-card>
    <slot v-if="!hideTitle" name="title" :refresh="refresh">
      <v-card-title>
        {{ title }}
        <v-btn @click="refresh()" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <slot name="append-title"></slot>
      </v-card-title>
    </slot>

    <v-card-text>
      <v-alert v-model="hasError" type="error" icon="mdi-connection">
        Não foi possível carregar os dados
        <v-btn @click="refresh()" text small>
          Tentar Novamente
        </v-btn>
      </v-alert>
    </v-card-text>

    <v-row v-if="!hideSearch" class="mx-1">
      <v-col cols="12" sm="6" offset-sm="6" md="4" offset-md="8">
        <v-text-field
          v-model="search"
          @keyup.enter="handleSearch()"
          solo
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar registro"
          hide-details
          clearable
          clear-icon="mdi-backspace-outline"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row class="mx-1">
      <v-col>
        <slot
          name="advancedFilters"
          :advancedFilters="advancedFilters"
          :refresh="handleSearch"
          :clear="clearFilters"
        ></slot>
      </v-col>
    </v-row>

    <v-data-table
      :value="value"
      @input="$emit('update', $event)"
      :items="items"
      :loading="loading"
      :headers="headers"
      :server-items-length="totalItems"
      :options.sync="options"
      must-sort
      :footer-props="{
        'show-current-page': true,
        'show-first-last-page': true,
        'items-per-page-options': itemsPerPageOptions
      }"
      v-bind="$attrs"
      @click:row="$emit('click:row', $event)"
    >
      <template
        v-for="(_, name) in $scopedSlots"
        :slot="name"
        slot-scope="slotData"
        ><slot :name="name" v-bind="slotData"
      /></template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    id: String,
    title: String,
    headers: Array,
    dataFetcher: Function,
    itemsPerPageOptions: {
      type: Array,
      default: () => [5, 10, 15, 50]
    },
    value: {
      type: Array,
      default: () => []
    },
    prepareItems: {
      type: Function,
      default: items => items
    },
    defaultFilters: {
      type: Object,
      default: () => ({})
    },
    hideSearch: Boolean,
    hideTitle: Boolean
  },

  model: {
    prop: "value",
    event: "update"
  },

  data() {
    return {
      items: [],
      loading: false,

      totalItems: 0,

      options: null,

      search: "",
      hasError: false,

      advancedFilters: {}
    };
  },

  methods: {
    handleSearch() {
      this.options.page = 1;

      this.refresh();
    },

    clearFilters() {
      this.advancedFilters = { ...this.defaultFilters };

      this.options.page = 1;

      this.refresh();
    },

    async refresh(options = null) {
      if (options === null) {
        options = this.options;
      }

      if (this.hasError) {
        this.hasError = false;
        this.options = {
          ...this.options,
          page: 1,
          itemsPerPage: 15,
          sortBy: [],
          sortDesc: []
        };
        return;
      }

      this.items = [];
      this.loading = true;

      try {
        const response = await this.dataFetcher({
          page: options.page,
          per_page: options.itemsPerPage,
          order_by: options.sortBy ? options.sortBy[0] : undefined,
          sort_order: options.sortDesc
            ? options.sortDesc[0]
              ? "DESC"
              : "ASC"
            : undefined,
          search: this.search,
          advanced_filters: this.advancedFilters
        });
        this.items = this.prepareItems(response.data);
        this.totalItems = response.meta.total;
        this.saveOptions(options, this.search, this.advancedFilters);
        this.$emit("refreshed", response);
      } catch (error) {
        console.error("Falha ao carregar dados", error);
        this.hasError = true;
      } finally {
        this.loading = false;
      }
    },

    handleUpdateOptions(options) {
      this.refresh(options);
    },

    saveOptions(options, search = "", advancedFilters = null) {
      if (advancedFilters === null) {
        advancedFilters = { ...this.defaultFilters };
      }

      if (!this.getStorageId()) {
        return;
      }

      if (!options) {
        localStorage.removeItem(this.getStorageId());
        return;
      }

      localStorage.setItem(
        this.getStorageId(),
        JSON.stringify({ options, search, advancedFilters })
      );
    },

    loadOptions() {
      const item = localStorage.getItem(this.getStorageId());

      if (!item) {
        return null;
      }

      try {
        const { options, search, advancedFilters } = JSON.parse(item);

        this.search = search;
        this.options = options;
        this.advancedFilters = advancedFilters;
      } catch (error) {
        console.error("Falha ao converter opções da tabela");

        return null;
      }
    },

    getStorageId() {
      if (!this.id) {
        return null;
      }

      return "table-" + this.id + "-options";
    }
  },

  computed: {},

  watch: {
    search(value, oldValue) {
      if (!value && !!oldValue) {
        this.handleSearch();
      }
    },

    options(value) {
      this.refresh(value);
    }
  },

  created() {
    this.loadOptions();
  }
};
</script>
